const STRINGS = {
  allSectionsButtonLabel: "All Sections",
  closeButtonLabel: "Close"
};
export default STRINGS;